import { i18n } from '@/plugins/i18n'
import { check } from '@/plugins/helper'

const getDefaultState = () => {
    return {
        activeBidRate               : 0,
        allowToModify               : false,
        agentPaymentStatus          : "",
        agentPaymentStatusId        : 0,
        bankAccountNo               : "",
        bankAccountName             : "",
        bankExpressId               : 0,
        bankId                      : 0,
        bankBranchId                : 0,
        bankName                    : "",
        bankTypeId                  : 0,
        beneficiaryAlias            : "",
        beneficiaryBank             : "",
        beneficiaryBankAccountName  : "",
        beneficiaryBankAccountNo    : "",
        beneficiaryBankId           : 0,
        beneficiaryBankBranch       : "",
        beneficiaryBankBranchId     : 0,
        beneficiaryFirstName        : "",
        beneficiaryFullName         : "",
        beneficiaryId               : 0,
        beneficiaryIdType           : 0,
        beneficiaryPhoneNo          : 0,
        beneficiaryTypeId           : 0,
        createdDateTime             : {year:0, month:0, dayOfMonth:0, hourOfDay:0, minute:0,second:0},
        billerCode                  : 0,
        billingOrg                  : "",
        city                        : "",
        cityId                      : 0,
        collectionAgent             : "",
        collectionAgentId           : 0,
        commissionAmount            : 0,
        contribution                : 0,
        contributionObj             : [],
        convenienceFee              : 0, // fee
        convenienceFeeByPercentage  : 0, // fee by percentage
        convenienceTotalFees        : 0, // totalFee
        couponCode                  : "",
        creditCardName              : "",
        creditCardNo                : "",
        creditCardExpiryDate        : "",
        creditCardSecurityCode      : "",
        deliveryDateTime            : {year:0, month:0, dayOfMonth:0, hourOfDay:0, minute:0,second:0},
        deliveryMethodId            : 0,
        deliveryMethod              : "",
        deliveryStatus              : "",
        deliveryStatusId            : 0,
        deliveryStatusHistoryList   : [],
        dmExternalName              : "",
        discountAmount              : 0,
        discountDescription         : "",
        discountName                : "",
        distributionPaymentStatus   : "",
        distributionPaymentStatusId : 0,
        endMonth                    : 0,
        endYear                     : null,
        exchangeRate                : 0,
        expressAvailable            : 0,
        externalDeliveryStatus      : "",
        flexiFund                   : null,
        homeAmount                  : "",
        homeAmountReal              : 0,
        homeCountryId               : 0,
        homeCountryIdd              : "",
        homeCountryName             : "",
        homeCurrency                : "",
        homeCurrencyId              : 0,
        hostAmount                  : "",
        hostAmountReal              : 0,
        hostCountryId               : 0,
        hostCountryName             : "",
        hostCurrency                : "",
        hostCurrencyId              : 0,
        identificationNo            : "",
        identificationType          :"",
        idTypeSelect                : "",
        idTypeSelectId              : "",
        isExpressBankType           : 0,
        isOutstanding               : false,
        isQuickSend                 : false,
        isSettled                   : false,
        isShowCancel                : false,
        isMakePayment               : false,
        latestState                 : "",
        loanNumber                  : '',
        memberTypeId                : 0,
        monthlyAmount               : 0,
        mp2No                       : '',
        p2hCustomerId               : 0,
        partnerId                   : 0,
        paymentDateTime             : {year:0, month:0, dayOfMonth:0, hourOfDay:0, minute:0,second:0},
        paymentMethodId             : 0,
        paymentMethod               : "",
        paymentPurpose              : "",
        paymentPurposeId            : 0,
        paymentPurposeOther         : "",
        paymentTime                 : "11:00 AM",
        prnNo                       : '',
        province                    : "",
        provinceId                  : 0,
        roundedAmount               : 0,
        serviceId                   : 0,
        settlementDetail            : "",
        settlementId                : 0,
        settlementPmId              : 0,
        settlementOutstandingAmount : 0,
        settlementStatusId          : 0,
        settlementTxnIds            : [],
        startMonth                  : 0,
        startYear                   : null,
        totSettlement               : 0,
        totalAmountPayable          : 0,
        totalAmountSettlement       : 0,
        totalAmountPaid             : [],
        totalReceivableAmountPaid   : [],
        transactionId               : 0,
        transactionType             : "",
        transactionTypeId           : 0,
        transactionIds              : [],
        transactionTypeIds          : [],
        transactionCharges          : 0,
        transactionChargesWaived    : false,
        transactionStatusName       : "",
        routerTo                    : "",
        isFromNotification          : false,

        // FX Calculator use, store
        FxRateHomeCountry           : [],
        FxRateDefaultHomeCountry    : [],

        //additional detail for transaction modification
        email              : "",
        homeIDD            : 0,
        homeIDDCode        : "",
        homeNo             : "",
        mobileIDD          : 0,
        mobileIDDCode      : "",
        mobileNo           : "",
        street             : "",
        postcode           : "",
        locatingNote       : "",
        landmark           : "",
        refNo              : "",
        walletNo           : "",

        isDisplayErrorMsg  : false,
        radioErrorMsg      : "",
        beneficiaryNameLabel    : "",
        identificationTypeLabel : "",
        identificationNoLabel   : "",
        bankAccountNoLabel      : "",
        refNoLabel              : "",
        mobileNoLabel           : "",
        emailLabel              : "",
        streetLabel             : "",

        validateInputState: {
            name                : "",
            value               : false,
        },

        forceRerenderKey: {
            componentPaymentPurposeKey      : 0,
            componentProvinceDetailsKey     : 1000,
            componentAudBtStateKey          : 10000,
            componentAudBtSuburbKey         : 100000,
            componentBTBankNameKey          : 1000000,
        },

        showPreloaderState: {
            name                : "",
            value               : false,
        },

        showFormSet: {
            billPayment             : false, //billaccountname, billaccount number
            collection              : false, //identificationType,idTypeSelect,identificationNo
            doorToDoor              : false, //street,postcode,locating note, landmark
        },

        showFormInput: {

            root: {
                beneficiaryName         : false,
                homeCountry             : true,
                homeNo                  : true,
                mobileNo                : true,
                email                   : true,
                paymentPurpose          : false,
                paymentPurposeOther     : false,
                bankAccountNo           : false,//cardNo
                identificationType      : false,
                idTypeSelect            : false,

                refNo                   : false,
                walletNo                : false,
            },
        },

        alertCard: {
            show   : false,
            title  : "",
            content: ""
        },

        transactionTypeList: [],
        idTypeList         : [],
        paymentPurposeList : [],
        billCorporationList: [],
        countryCodeList    : [],
        provinceList         : [],
        homeCountryList      : [],


        isDisplayBillPayment    : false,
        isFormInputValid        : false,
    }

}

const state = getDefaultState()

const getters = {

    showFormSet: (state) => {
        return state.showFormSet
    },
    showFormInput: (state) => {
        return state.showFormInput
    },
    validateInputState: (state) => {
        return state.validateInputState
    },
    forceRerenderKey: (state) => {
        return state.forceRerenderKey
    },
    showPreloaderState: (state) => {
        return state.showPreloaderState
    },
    alertCard: (state) => {
        return state.alertCard
    },
    bankTypeId: (state) => {
        return state.bankTypeId
    },
    settlementStatusId: (state) => {
        return state.settlementStatusId
    },
    transactionId: (state) => {
        return state.transactionId
    },
    transactionTypeList: (state) => {
        return state.transactionTypeList
    },
    transactionTypeId: (state) => {
        return state.transactionTypeId
    },
    transactionType: (state) => {
        return state.transactionType
    },
    deliveryMethod: (state) => {
        return state.deliveryMethod
    },
    deliveryMethodId: (state) => {
        return state.deliveryMethodId
    },
    dmExternalName: (state) => {
        return state.dmExternalName
    },
    homeCountryId: (state) => {
        return state.homeCountryId
    },
    homeCountryIdd: (state) => {
        return state.homeCountryIdd
    },
    homeCountryName: (state) => {
        return state.homeCountryName
    },
    homeCountryList: (state) => {
        return state.homeCountryList
    },
    homeCurrency: (state) => {
        return state.homeCurrency
    },
    homeCurrencyId: (state) => {
        return state.homeCurrencyId
    },
    hostCountryId: (state) => {
        return state.hostCountryId
    },
    hostCountryName: (state) => {
        return state.hostCountryName
    },
    hostCurrency: (state) => {
        return state.hostCurrency
    },
    hostCurrencyId: (state) => {
        return state.hostCurrencyId
    },
    homeIDD: (state) => {
        return state.homeIDD
    },
    homeIDDCode: (state) => {
        return state.homeIDDCode
    },
    mobileIDD: (state) => {
        return state.mobileIDD
    },
    mobileIDDCode: (state) => {
        return state.mobileIDDCode
    },
    isbKashTx: (state) => {
        return state.isbKashTx
    },
    isDisplayErrorMsg: (state) => {
        return state.isDisplayErrorMsg
    },
    radioErrorMsg: (state) => {
        return state.radioErrorMsg
    },
    identificationTypeLabel: (state) => {
        return state.identificationTypeLabel
    },
    identificationNoLabel: (state) => {
        return state.identificationNoLabel
    },
    bankAccountNoLabel: (state) => {
        return state.bankAccountNoLabel
    },
    refNoLabel: (state) => {
        return state.refNoLabel
    },
    mobileNoLabel: (state) => {
        return state.mobileNoLabel
    },
    emailLabel: (state) => {
        return state.emailLabel
    },
    beneficiaryName: (state) => {
        return state.beneficiaryFullName
    },
    beneficiaryNameLabel: (state) => {
        return state.beneficiaryNameLabel
    },
    beneficiaryTypeId: (state) => {
        return state.beneficiaryTypeId
    },
    countryCodeList: (state) => {
        return state.countryCodeList
    },
    identificationType: (state) => {
        return state.identificationType
    },
    idTypeSelect: (state) => {
        return state.idTypeSelect
    },
    idTypeSelectId: (state) => {
        return state.idTypeSelectId
    },
    idTypeList: (state) => {
        return state.idTypeList
    },
    identificationNo: (state) => {
        return state.identificationNo
    },
    bankAccountNo: (state) => {
        return state.bankAccountNo
    },
    walletNo: (state) => {
        return state.walletNo
    },
    bankAccountName: (state) => {
        return state.bankAccountName
    },
    paymentPurpose: (state) => {
        return state.paymentPurpose
    },
    paymentPurposeId: (state) => {
        return state.paymentPurposeId
    },
    paymentPurposeOther: (state) => {
        return state.paymentPurposeOther
    },
    paymentPurposeList: (state) => {
        return state.paymentPurposeList
    },
    provinceList: (state) => {
        return state.provinceList
    },
    refNo: (state) => {
        return state.refNo
    },
    billCorporationList: (state) => {
        return state.billCorporationList
    },
    street: (state) => {
        return state.street
    },
    postcode: (state) => {
        return state.postcode
    },
    locatingNote: (state) => {
        return state.locatingNote
    },
    landmark: (state) => {
        return state.landmark
    },
    homeNo: (state) => {
        return state.homeNo
    },
    mobileNo: (state) => {
        return state.mobileNo
    },
    email: (state) => {
        return state.email
    },
    isDisplayBillPayment: (state) => {
        return state.isDisplayBillPayment
    },
    isDisplayCollection: (state) => {
        return state.isDisplayCollection
    },
    isDisplayDoorToDoor: (state) => {
        return state.isDisplayDoorToDoor
    },
    isDisplayPostcode: (state) => {
        return state.isDisplayPostcode
    },
    isDisplayBeneficiaryName: (state) => {
        return state.isDisplayBeneficiaryName
    },
    isDisplayIdType: (state) => {
        return state.isDisplayIdType
    },
    isDisplayIdTypeSelect: (state) => {
        return state.isDisplayIdTypeSelect
    },
    isDisplayIdNo: (state) => {
        return state.isDisplayIdNo
    },
    isDisplayAccountNo: (state) => {
        return state.isDisplayAccountNo
    },
    isDisplayWalletNo: (state) => {
        return state.isDisplayWalletNo
    },
    isDisplayRefNo: (state) => {
        return state.isDisplayRefNo
    },
    isDisplayPaymentPurpose: (state) => {
        return state.isDisplayPaymentPurpose
    },
    isDisplayPaymentPurposeOther: (state) => {
        return state.isDisplayPaymentPurposeOther
    },
    isDisplayHomeNo: (state) => {
        return state.isDisplayHomeNo
    },
    isDisplayMobileNo: (state) => {
        return state.isDisplayMobileNo
    },
    isDisplayEmail: (state) => {
        return state.isDisplayEmail
    },
    streetLabel: (state) => {
        return state.streetLabel
    },
    isValidBillCorp: (state) => {
        return state.isValidBillCorp
    },
    isValidBeneficiaryName: (state) => {
        return state.isValidBeneficiaryName
    },
    isValidIdType: (state) => {
        return state.isValidIdType
    },
    isValidIdTypeSelect: (state) => {
        return state.isValidIdTypeSelect
    },
    isValidIdNo: (state) => {
        return state.isValidIdNo
    },
    isValidStreet: (state) => {
        return state.isValidStreet
    },
    isValidPostcode: (state) => {
        return state.isValidPostcode
    },
    isValidAccountNo: (state) => {
        return state.isValidAccountNo
    },
    isValidWalletNo: (state) => {
        return state.isValidWalletNo
    },
    isValidRefNo: (state) => {
        return state.isValidRefNo
    },
    isValidPaymentPurpose: (state) => {
        return state.isValidPaymentPurpose
    },
    isValidHomeNo: (state) => {
        return state.isValidHomeNo
    },
    isValidMobileNo: (state) => {
        return state.isValidMobileNo
    },
    isValidEmail: (state) => {
        return state.isValidEmail
    },
    isValidCheckOnlySpecial: (state) => {
        return state.isValidCheckOnlySpecial
    },
    isFormInputValid: (state) => {
        return state.isFormInputValid
    },
}

const actions = {
    resetBeneficiaryState ({ commit }) {
        commit('resetTransactionState')
    },

    displayBillPayment({ commit }, params) {
        let isDisplay     = false
        let isBillPayment = (params.txTypeId == 4 || params.dmId == 0) ? true : false
        // console.log("isBillPayment: " + isBillPayment);

        // BILL PAYMENT
        isDisplay = isBillPayment ? true : false
        // console.log("loadIsDisplayBillPayment: " + isDisplay);

        commit('loadIsDisplayBillPayment', isDisplay);
    },

    displayBankTransfer({ commit }, params) {
        let isDisplay      = false
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false
        let isCashCard     = (params.txTypeId == 5 || params.txTypeId == 103 || params.dmId == 6) ? true : false

        // console.log("isBankTransfer: " + isBankTransfer);
        // console.log("isCashCard: " + isCashCard);
        // console.log("isUpi: " + isUpi);
        // console.log("isPhilGov: " + isPhilGov);
        // console.log("isWallet: " + isWallet);

        // BANK TRANSFER || CASH CARD || UPI || PHIL GOV || WALLET
        isDisplay = (isBankTransfer || isCashCard ) ? true : false

        // console.log("loadIsDisplayBankTransfer: " + isDisplay);
        commit('loadIsDisplayBankTransfer', isDisplay);
    },

    displayCollection({ commit }, params) {
        let isDisplay    = false
        let isCollection = (params.dmId == 3) ? true : false
        let isDoorToDoor = (params.dmId == 4) ? true : false

        // COLLECTION OR DOOR TO DOOR
        isDisplay = (isCollection || isDoorToDoor) ? true : false

        commit('loadIsDisplayCollection', isDisplay);
    },

    displayDoorToDoor({ commit }, params) {
        let isDisplay    = false
        let isDoorToDoor =  (params.dmId == 4) ? true : false

        // DOOR TO DOOR
        isDisplay = isDoorToDoor ? true : false
        console.log("DISPLAY DOOR TO DOOR", isDisplay);

        commit('loadIsDisplayDoorToDoor', isDisplay);
    },

    displayBeneficiaryName({ commit }, params) {
        let isDisplay     = false
        let displayLabel  = ""
        let isBillPayment = (params.txTypeId == 4 || params.dmId == 0) ? true : false

        isDisplay = isBillPayment ? false : true;
        displayLabel = i18n.t('beneficiary-fullname');

        const result = {
            isDisplay: isDisplay,
            label    : displayLabel,
        }
        commit('loadIsDisplayBeneficiaryName', result);
    },

    displayIdType({ commit }, params) {
        let isDisplay    = false
        let displayLabel = ""
        let isCollection = (params.txTypeId == 3 || params.dmId == 3) ? true : false
        let isDoorToDoor = (params.dmId == 4) ? true : false

        // DOOR TO DOOR
        //    || (COLLECTION && (95 - HONG KONG S.A.R. || 99 - INDONESIA || 145 - MYANMAR || 167 - PHILIPPINES || 228 - VIETNAM || 236 - VIETNAM USD))
        // DOOR TO DOOR
        //    || (COLLECTION && (95 - HONG KONG S.A.R. || 99 - INDONESIA || 145 - MYANMAR || 167 - PHILIPPINES || 228 - VIETNAM || 236 - VIETNAM USD))
        if(isDoorToDoor
            || (isCollection && (params.countryId == 95 || params.countryId == 99 || params.countryId == 145
                || params.countryId == 167 || params.countryId == 228 || params.countryId == 236))
        ) {
            isDisplay = true;
        }

        console.log("ISDISLAY ID TYPE", isDisplay)

        // COLLECTION && 167 - PHILIPPINES
        displayLabel = (isCollection && params.countryId == 167) ? i18n.t('beneficiary-beneficiary-id-type-optional') : i18n.t('beneficiary-beneficiary-id-type');


        const result = {
            isDisplay: isDisplay,
            label    : displayLabel,
        }
        commit('loadIsDisplayIdType', result);
    },

    displayIdTypeSelect({ commit }, params) {
        let isDisplay    = false
        let isCollection = (params.txTypeId == 3 || params.dmId == 3) ? true : false

        // COLLECTION
         // COLLECTION && (18 - BANGLADESH || 98 - INDIA || 197 - SRI LANKA))
         if(isCollection && (params.countryId == 18 || params.countryId == 98 || params.countryId == 197)) {
            isDisplay = true;
        }


        commit('loadIsDisplayIdTypeSelect', isDisplay);
    },

    displayIdNo({ commit }, params) {
        let isDisplay    = false
        let displayLabel = ""
        let isCollection = (params.txTypeId == 3 || params.dmId == 3) ? true : false
        let isDoorToDoor = (params.dmId == 4) ? true : false


        //COLLECTION
        isDisplay = (isCollection || isDoorToDoor) ? true : false;

        // COLLECTION
        displayLabel = i18n.t('beneficiary-beneficiary-id-no');

        const result = {
            isDisplay: isDisplay,
            label    : displayLabel,
        }
        commit('loadIsDisplayIdNo', result);
    },

    displayAccountNo({ commit }, params) {
        let isDisplay      = false
        let displayLabel   = ""
        let isBankTransfer = (params.dmId == 1 ) ? true : false
        let isCashCard     = (params.dmId == 6) ? true : false
        let isBillPayment  = ( params.dmId == 0) ? true : false
        //let isWallet       = (state.transactionTypeId == 2 && state.deliveryMethodId == 1 && state.bankTypeId == 2) ? true : false
        

        // BANK TRANSFER || CASH CARD || BILL PAYMENT
        isDisplay = (isBankTransfer || isCashCard || isBillPayment) ? true : false
        console.log("DISPLAY ACCOUNT NO", isDisplay)

        // BANK TRANSFER
        if(isBankTransfer) {
            displayLabel = i18n.t('beneficiary-bank-account-no')
        }
        // CASH CARD
        else if(isCashCard) {
            // 18 - BANGLADESH
            if(params.countryId == 18) {
                displayLabel = i18n.t('beneficiary-bkash-no')
            }
            // 167 - PHILIPPINES
            else if(params.countryId == 167) {
                displayLabel = i18n.t('beneficiary-cash-card-no')
            }
        }

        const result = {
            isDisplay: isDisplay,
            label    : displayLabel,
        }

        commit('loadIsDisplayAccountNo', result);
    },

    displayRefNo({ commit }, params) {
        let isDisplay     = false
        let displayLabel  = ""
        let isCollection  = (params.txTypeId == 3 || params.dmId == 3) ? true : false
        let isBillPayment = (params.txTypeId == 4 || params.dmId == 0) ? true : false

        //
        isDisplay = (!isBillPayment) ? true : false

        // COLLECTION
        if(isCollection) {
            // 95 - HONG KONG S.A.R.
            if(params.countryId == 95) {
                displayLabel = i18n.t('beneficiary-ref-no-col-point')
            }
            // 99 - INDONESIA
            else if(params.countryId == 99) {
                displayLabel = i18n.t('beneficiary-ref-no-optional')
            } else {
                displayLabel = i18n.t('beneficiary-ref-no-col-point-optional')
            }
        } else {
                displayLabel = i18n.t('beneficiary-ref-no-col-point-optional')
        }


        const result = {
            isDisplay: isDisplay,
            label    : displayLabel,
        }
        commit('loadIsDisplayRefNo', result);
    },

    displayPaymentPurpose({ commit }, params) {
        let isDisplay     = false
        let isBillPayment = (params.txTypeId == 4 || params.dmId == 0) ? true : false

        // NOT BILL PAYMENT
        isDisplay = (!isBillPayment) ? true : false

        commit('loadIsDisplayPaymentPurpose', isDisplay);
    },

    displayPaymentPurposeOther({ commit }, params) {
        let isDisplay     = false
        let isBillPayment = (params.txTypeId == 4 || params.dmId == 0) ? true : false

        // NOT BILL PAYMENT
        isDisplay = (!isBillPayment && params.ppId == -1) ? true : false

        commit('loadIsDisplayPaymentPurposeOther', isDisplay);
    },

    displayMobileNo({ commit }, params) {
        let isDisplay      = false
        let displayLabel   = ""
        let isBankTransfer = ( params.dmId == 1) ? true : false
        let isDoorToDoor   = ( params.dmId == 4) ? true : false
        let isCollection   = ( params.dmId == 3) ? true : false
        //let isPhilGov      = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false

        // NOT PHIL GOV
        isDisplay = true

        // (BANK TRANSFER && (13 - AUSTRALIA || 111 - S.KOREA || 228 - VIETNAM)) || DOOR TO DOOR || COLLECTION
        if((isBankTransfer && (params.countryId == 13 || params.countryId == 111 || params.countryId == 228))
            || isDoorToDoor || isCollection
        ) {
            displayLabel = i18n.t('beneficiary-mobile-no')
        } else {
            displayLabel = i18n.t('beneficiary-mobile-no-optional')
        }

        const result = {
            isDisplay: isDisplay,
            label    : displayLabel,
        }
        commit('loadIsDisplayMobileNo', result);
    },

    displayEmail({ commit }, params) {
        let isDisplay    = false
        let displayLabel = ""
        let isPhilGov    = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false

        // NOT PHIL GOV && (NOT 4521 - Pag-IBIG || NOT 4522 - SSS)
        isDisplay = !(isPhilGov && (params.bankId == 4521 || params.bankId == 4522)) ? true : false

        // PHIL GOV && 4520 - PhilHealth
        displayLabel = (isPhilGov && params.bankId == 4520) ? i18n.t('beneficiary-email') : i18n.t('beneficiary-email-optional')

        const result = {
            isDisplay: isDisplay,
            label    : displayLabel,
        }
        commit('loadIsDisplayEmail', result);
    },

    validateBillCorp({ commit }, value) {
        let billCorpId = value;
        let inputState = (billCorpId > 0) ? true : i18n.t('beneficiary-bill-corp-error');
        commit('loadIsValidBillCorp', inputState);
    },

    validateBeneficiaryName({ commit, dispatch }, params) {
        let beneName      = params.name;
        let bankAccountName =  params.name;
        let isValidInput  = true;
        let inputState    = "";
        let isBillPayment = (params.txTypeId == 4 || params.txTypeId == 1 || params.dmId == 0) ? true : false

        let msg1 = i18n.t('beneficiary-fullname-error1');
        let msg2 = i18n.t('beneficiary-fullname-error2');
        let msg3 = i18n.t('beneficiary-fullname-error3');
        // 4 - BILL PAYMENT
        if(isBillPayment) {
            msg1 = i18n.t('beneficiary-bill-account-name-error1');
            msg2 = i18n.t('beneficiary-bill-account-name-error1');
            msg3 = i18n.t('beneficiary-bill-account-name-error1');
            dispatch('checkPreventOnlySpecial', bankAccountName);
        }else{
            dispatch('checkPreventOnlySpecial', beneName);
        }


        let chkSpcResult = this.state.transaction.isValidCheckOnlySpecial;
        if(chkSpcResult < 0) {
            isValidInput = false;
            switch(chkSpcResult) {
                case -1:
                    inputState = isValidInput ? true : msg1;
                    break;
                case -2:
                    inputState = isValidInput ? true : msg2;
                    break;
                case -3:
                    inputState = isValidInput ? true : msg3;
                    break;
            }
        } else {
            isValidInput = true;
            inputState   = true;
        }
        commit('loadIsValidBeneficiaryName', inputState);
    },

    validateIdentificationType({ commit }, params) {
        let beneIdType   = params.idType != undefined ? params.idType.trim() : params.idType;
        let isValidInput = true;
        let inputState   = "";
        let msg          = "";

        // If not 167 - PHILIPPINES, then mandatory
        if(params.countryId != 167) {
            isValidInput = beneIdType.length > 0;
            msg          = i18n.t('beneficiary-beneficiary-id-type-help');
        }

        if(beneIdType.length > 0) {
            isValidInput = check.validPattern("alphaNumericSpaces", beneIdType);
            msg          = i18n.t('beneficiary-beneficiary-id-type-help');
        }

        inputState = isValidInput ? true : msg;
        console.log("idtype inputState: "+inputState);
        commit('loadIsValidIdType', inputState);
    },

    validateIdTypeSelect({ commit }, value) {
        let idTypeId   = value;
        let inputState = (idTypeId > 0) ? true : i18n.t('beneficiary-beneficiary-id-type-select-help');
        commit('loadIsValidIdTypeSelect', inputState);
    },

    validateIdentificationNo({ commit }, params) {
        let beneIdNo     = params.idNo != undefined ? params.idNo.trim() : params.idNo;
        let isValidInput = true;
        let inputState   = "";
        let msg          = "";

        // If not 167 - PHILIPPINES, then mandatory
        if(params.countryId != 167) {
            isValidInput = beneIdNo.length > 0;
            msg          = i18n.t('beneficiary-beneficiary-id-no-help');
        }

        if(beneIdNo.length > 0) {
            isValidInput = check.validPattern("alphaNumericSpaces", beneIdNo);
            msg          = i18n.t('beneficiary-beneficiary-id-no-help');
        }

        inputState = isValidInput ? true : msg;
        commit('loadIsValidIdNo', inputState);
    },

    validateStreet({ commit }, value) {
        let street     = value != undefined ? value.trim() : value;
        let inputState = (street.length > 0) ? true : i18n.t('beneficiary-street-help');
        commit('loadIsValidStreet', inputState);
    },

    async validatePostcode({ commit, state }, params) {
        let postcode       = state.postcode.trim();//params.postcode != undefined ? params.postcode.trim() : params.postcode;
        let isValidInput   = true;
        let inputState     = "";
        let msg            = "";
        //let isBankTransfer = (state.txTypeId == 1 || params.dmId == 1) ? true : false
        let provinceId     = 0;

        if(postcode != undefined && postcode.length > 0) {
            isValidInput = check.validPattern("number", postcode);
            msg          = i18n.t('beneficiary-postcode-numerical-format');
        }

        // 13 - AUSTRALIA
        if(params.countryId == 13) {
            // this.showPreloader();
            const cityPromise = await this.$api.beneficiary.getCityByPostcode(postcode);
            const cList       = cityPromise;

            isValidInput = cList.length > 1 && params.provinceId > 0
            msg          = i18n.t('beneficiary-postcode-info')

            if(cList.length > 1) {
                if(params.provinceId > 0) {
                    let filterProvinceId = cList.filter(city => city.provinceId == params.provinceId);
                    if(filterProvinceId.length > 0) {
                        let cityDetails = filterProvinceId.filter(cd => cd.id == params.cityId);
                        provinceId = cityDetails[0].provinceId
                    }
                } else {
                    provinceId = cList[0].provinceId
                }
            } else if(cList.length == 1) {
                provinceId = cList[0].provinceId
            }
            // this.hidePreloader();
        }
        inputState = isValidInput ? true : msg;

        const result = {
            inputState : inputState,
            provinceId : provinceId,
        }
        commit('loadIsValidPostcode', result);
    },

    validateAccountNo({ commit }, params) {
        let accountNo      = params.accountNo;
        let isValidInput   = true;
        let inputState     = "";
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false
        let isCashCard     = (params.txTypeId == 5 || params.txTypeId == 103 || params.dmId == 6) ? true : false
        let isBillPayment  = (params.txTypeId == 4 || params.dmId == 0) ? true : false
        let isWallet       = (params.txTypeId == 2 && params.dmId == 1 && params.bankTypeId == 2) ? true : false

        let helpMsg  = i18n.t('beneficiary-bank-account-no-help');
        let errorMsg = i18n.t('beneficiary-bank-account-no-error');

        // BKASH && 18 - BANGLADESH
        if(isCashCard && params.countryId == 18) {
            helpMsg  = i18n.t('beneficiary-bkash-no-help');
            errorMsg = i18n.t('beneficiary-bkash-no-error');
        }
        // CASH CARD && 167 - PHILIPPINES
        else if(isCashCard && params.countryId == 167) {
            helpMsg  = i18n.t('beneficiary-cash-card-no-help');
            errorMsg = i18n.t('beneficiary-cash-card-no-error');
        }
        // BILL PAYMENT
        else if(isBillPayment) {
            helpMsg  = i18n.t('beneficiary-bill-account-no-help');
            errorMsg = i18n.t('beneficiary-bill-account-no-error');
        }


        isValidInput = accountNo.length > 0;
        inputState   = isValidInput ? true : helpMsg

        if(isValidInput) {
            // If not Vietnam and European Union (EU), then allow only numeric account number
            // Skip this validation for UPI
            if(params.countryId != 228 && params.countryId != 238) {
                isValidInput = check.validPattern("number", accountNo);
                inputState   = isValidInput ? true : errorMsg
                if(isWallet){
                    commit('loadIsValidWalletNo', inputState);
                }else{
                    commit('loadIsValidAccountNo', inputState);
                }
            }
            // Vietnam and European Union (EU), allow alpha numeric account number
            // Skip this validation for UPI
            else if(params.countryId == 228 || params.countryId == 238)  {
                isValidInput = check.validPattern("alphanumeric", accountNo);
                inputState   = isValidInput ? true : helpMsg;
                commit('loadIsValidAccountNo', inputState);
            }

            // BANK TRANSFER && 221 - UNITED KINGDOM
            if(isBankTransfer && params.countryId == 221) {
                isValidInput = accountNo.length == 8;
                inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error2');
            }

            // 99 - INDONESIA
            if(params.countryId == 99) {
                if(params.bankId == 77 || params.bankId == 1918) {
                    isValidInput = accountNo.length == 15;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error3', {digit:15});
                }

                if(params.bankId == 67 || params.bankId == 1919 || params.bankId == 2010) {
                    isValidInput = accountNo.length == 13;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error3', {digit:13});
                }

                // Wallet
                if(isWallet) {
                    let isValidInputPattern = check.validPattern("number", accountNo);
                    inputState   = isValidInputPattern ? true : errorMsg
                    isValidInput = isValidInputPattern ? true : false

                    if(isValidInputPattern){
                        isValidInput = !(/* accountNo.substring(0, 2) != 62 || */ accountNo.length < 9 || accountNo.length > 12);
                        inputState   = isValidInput ? true : i18n.t('beneficiary-mobile-topup-no-error2');
                    }
                }

            }

            // BANK TRANSFER && 18 - BANGLADESH
            if(isBankTransfer && params.countryId == 18) {
                isValidInput = accountNo.length >= 9;
                inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error3', {digit:'>=9'});
            }

            // BANK TRANSFER && 167 - PHILIPPINES
            if(isBankTransfer && params.countryId == 167) {
                if (params.bankId == 1 || params.bankId == 4 || params.bankId == 484 || params.bankId == 30 || params.bankId == 520 || params.bankId == 481 || params.bankId == 3734 || params.bankId == 3735 || params.bankId == 1649 || params.bankId == 24 || params.bankId == 530 || params.bankId == 29 || params.bankId == 522 || params.bankId == 35 || params.bankId == 514) {
                    isValidInput = accountNo.length == 10;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error3', {digit:10});
                } else if (params.bankId == 25 || params.bankId == 528) {
                    isValidInput = accountNo.length == 11;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error3', {digit:11});
                } else if (params.bankId == 1350 || params.bankId == 3716 || params.bankId == 6 || params.bankId == 487 || params.bankId == 26 || params.bankId == 526 || params.bankId == 2301 || params.bankId == 15 || params.bankId == 504 || params.bankId == 44 || params.bankId == 496 || params.bankId == 1823 || params.bankId == 21 || params.bankId == 532 || params.bankId == 23 || params.bankId == 531 || params.bankId == 40 || params.bankId == 507 || params.bankId == 41 || params.bankId == 500 || params.bankId == 45 || params.bankId == 495 || params.bankId == 1823 || params.bankId == 12) {
                    isValidInput = accountNo.length == 12;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error3', {digit:12});
                } else if (params.bankId == 48 || params.bankId == 47 || params.bankId == 491 || params.bankId == 489) {
                    isValidInput = accountNo.length == 13;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error3', {digit:13});
                } else if (params.bankId == 31 || params.bankId == 518) {
                    isValidInput = accountNo.length == 10 || accountNo.length == 11;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error3', {digit:'10 / 11'});
                } else if (params.bankId == 14 || params.bankId == 503) {
                    isValidInput = accountNo.length == 10 || accountNo.length == 12 || accountNo.length == 13;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error3', {digit:'10 / 12 / 13'});
                } else if (params.bankId == 5 || params.bankId == 485 || params.bankId == 9 || params.bankId == 494 || params.bankId == 2032 || params.bankId == 17 || params.bankId == 521 || params.bankId == 22 || params.bankId == 533 || params.bankId == 18 || params.bankId == 2112 || params.bankId == 482 || params.bankId == 2 || params.bankId == 524) {
                    isValidInput = accountNo.length == 10 || accountNo.length == 12;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error3', {digit:'10 / 12'});
                } else if (params.bankId == 8 || params.bankId == 492 || params.bankId == 16 || params.bankId == 519) {
                    isValidInput = accountNo.length == 10 || accountNo.length == 13;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error3', {digit:'10 / 13'});
                } else if (params.bankId == 7 || params.bankId == 490 || params.bankId == 32 || params.bankId == 20 || params.bankId == 529 || params.bankId == 517) {
                    isValidInput = accountNo.length == 10 || accountNo.length == 16;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error3', {digit:'10 / 16'});
                } else if (params.bankId == 13 || params.bankId == 502) {
                    isValidInput = accountNo.length == 11 || accountNo.length == 12;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error3', {digit:'11 / 12'});
                } else if (params.bankId == 36 || params.bankId == 512){
                    isValidInput = accountNo.length == 12 || accountNo.length == 15;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error3', {digit:'12 / 15'});
                }
            }
        }

        if(isWallet){
            commit('loadIsValidWalletNo', inputState);
        }else{
            commit('loadIsValidAccountNo', inputState);
        }
    },

    validateRefNote({ commit, dispatch }, params) {
        let refNo         = params.refNo;
        let isValidInput  = true;
        let inputState    = "";
        let isCollection  = (params.txTypeId == 3 || params.dmId == 3) ? true : false
        //let isBillPayment = (params.txTypeId == 4 || params.dmId == 0) ? true : false

        dispatch('checkPreventOnlySpecial', refNo);
        let chkSpcResult = this.state.beneficiary.isValidCheckOnlySpecial;
        if(chkSpcResult < -1) {
            isValidInput = false;
            switch(chkSpcResult) {
                case -2:
                    inputState = isValidInput ? true : i18n.t('beneficiary-ref-no-error2');
                    break;
                case -3:
                    inputState = isValidInput ? true : i18n.t('beneficiary-ref-no-error3');
                    break;
            }
        } else {
            // (COLLECTION && 95 - HONG KONG S.A.R.)
            if(isCollection && params.countryId == 95){
                isValidInput = refNo.length > 0;
                inputState   = isValidInput ? true : i18n.t('beneficiary-ref-no-error');
            } else {
                isValidInput = true;
                inputState   = true;
            }
        }
        commit('loadIsValidRefNo', inputState);
    },

    validatePaymentPurpose({ commit, dispatch }, params) {
        let ppId       = params.ppId;
        let inputState = "";

        inputState = (ppId > 0 || ppId == -1) ? true : i18n.t('beneficiary-payment-purpose-error');

        if(ppId == -1) {
            dispatch('validateOtherPaymentPurpose', params.ppOther);
            inputState = this.state.transaction.isValidPaymentPurpose;
        }
        commit('loadIsValidPaymentPurpose', inputState);
    },

    validateOtherPaymentPurpose({ commit, dispatch }, value) {
        let ppOther      = value;
        let isValidInput = true;
        let inputState   = "";

        dispatch('checkPreventOnlySpecial', ppOther);
        let chkSpcResult = this.state.transaction.isValidCheckOnlySpecial;
        if(chkSpcResult < 0) {
            isValidInput = false;
            switch(chkSpcResult) {
                case -1:
                    inputState = isValidInput ? true : i18n.t('beneficiary-payment-purpose-error');
                    break;
                case -2:
                    inputState = isValidInput ? true : i18n.t('beneficiary-payment-purpose-error2');
                    break;
                case -3:
                    inputState = isValidInput ? true : i18n.t('beneficiary-payment-purpose-error3');
                    break;
            }
        } else {
            isValidInput = true;
            inputState   = true;
        }
        commit('loadIsValidPaymentPurpose', inputState);
    },

    validateHomeNo({ commit }, params) {
        let homeNoTemp   = params.homeNo != undefined ? params.homeNo.trim() : params.homeNo;
        let isValidInput = true;
        let inputState   = "";
        let homeIDD      = params.homeIDD;

        if(homeNoTemp.length == 0) {
            isValidInput = true;
            inputState   = true;
        } else if(homeNoTemp.length > 0) {
            isValidInput = homeIDD > 0;
            inputState   = isValidInput ? true : i18n.t('beneficiary-phone-code-error');

            isValidInput = homeNoTemp != "0";
            inputState   = isValidInput ? true : i18n.t('beneficiary-home-no-error');

            let firstDigitHome = homeNoTemp.substring(0, 1);
            if(firstDigitHome == 0 && params.countryId == 99) {
                homeNoTemp   = homeNoTemp.substring(0, 1);
                isValidInput = true;
            }

            isValidInput = check.validPattern("number", homeNoTemp);
            inputState   = isValidInput ? true : i18n.t('beneficiary-home-no-error2');
        }
        commit('loadIsValidHomeNo', inputState);
    },

    validateMobileNo({ commit }, params) {
        let mobileNoTemp   = params.mobileNo != undefined ? params.mobileNo.trim() : params.mobileNo;
        let isValidInput   = true;
        let inputState     = "";
        let mobileIDD      = params.mobileIDD;
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false
        let isDoorToDoor   = (params.txTypeId == 2 || params.dmId == 4) ? true : false
        let isCollection   = (params.txTypeId == 3 || params.dmId == 3) ? true : false

        if(mobileNoTemp.length == 0) {
            isValidInput = true;
            inputState   = true;
        } else if(mobileNoTemp.length > 0) {
            isValidInput = mobileIDD > 0;
            inputState   = isValidInput ? true : i18n.t('beneficiary-phone-code-error');

            isValidInput = mobileNoTemp != "0";
            inputState   = isValidInput ? true : i18n.t('beneficiary-mobile-no-error');

            let firstDigitMobile = mobileNoTemp.substring(0, 1);
            if(firstDigitMobile == 0 && params.countryId == 99) {
                mobileNoTemp = mobileNoTemp.substring(0, 1);
                isValidInput = true;
            }

            isValidInput = check.validPattern("number", mobileNoTemp);
            inputState   = isValidInput ? true : i18n.t('beneficiary-mobile-no-error3');
        }

        // (BANK TRANSFER && (13 - AUSTRALIA || 111 - S.KOREA || 228 - VIETNAM)) || DOOR TO DOOR || COLLECTION
        if(
            (isBankTransfer && (params.countryId == 13 || params.countryId == 111 || params.countryId == 228))
            || isDoorToDoor || isCollection
        ) {
            isValidInput = mobileNoTemp.length > 0;
            inputState   = isValidInput ? true : i18n.t('beneficiary-mobile-no-error2');
        }
        commit('loadIsValidMobileNo', inputState);
    },

    validateEmail({ commit }, params) {
        let email        = params.email != undefined ? params.email.trim() : params.email;
        let isValidInput = true;
        let inputState   = "";
        let msg          = "";
        let isPhilGov    = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false

        if(email.length > 0) {
            isValidInput = check.validPattern("email", email);
            msg = i18n.t('beneficiary-email-error');
        }

        // 101 - PHIL GOV SERVICE && 167 - PHILIPPINES && 4520 - PhilHealth
        if(isPhilGov && params.countryId == 167 && params.bankId == 4520) {
            isValidInput = email.length > 0 && check.validPattern("email", email);
            msg = i18n.t('beneficiary-email-help');
        }

        inputState = isValidInput ? true : msg;
        commit('loadIsValidEmail', inputState);
    },

    checkPreventOnlySpecial({ commit }, value) {
        let specialList  = ['.', ',', '!', '!', '{ ', '}', '<', '>', '?', ':', ';', '\u2013', '\u2014', '-', '(', ')', '[', ']', '\'', '"', '\u2018', '\u0060', '\u2019', '\u201C', '\u201D', '^', '@', '~', '`', '$', '%', '*', '_', '|', '/', '&'];
        let val          = value;
        let removedWhite = val.replace(/\s+/g,'');
        let len          = val.length, removedLen = removedWhite.length;
        let i            = 0, spcCount = 0, checkChar = 0;
        if(len == 0) { // must not be empty!
            commit('loadCheckPreventOnlySpecial', -1);
        } else if(removedLen == 0) { // considered error, because the value contains only white spaces.
            commit('loadCheckPreventOnlySpecial', -2);
        } else {
            spcCount = 0;
            for(i = 0; i < removedLen; i++) {
                checkChar = removedWhite.charAt(i);
                if(specialList.indexOf(checkChar)>-1) { // if in list of Special Character, add to count.
                    spcCount++;
                }
            }
            if(spcCount == removedLen) { // considered error, because the value contains only special characters.
                commit('loadCheckPreventOnlySpecial', -3);
            } else {
                commit('loadCheckPreventOnlySpecial', 0);
            }
        }
    },

     /* SHOW/HIDE INPUT*/
    showHideInput({ dispatch, state }) {

        const params = {
            countryId : state.homeCountryId,
            txTypeId  : state.transactionTypeId,
            dmId      : state.deliveryMethodId,
            bankId    : state.beneficiaryBankId,
            bankTypeId: state.bankTypeId,
            caId      : state.beneficiaryBankId,
            provinceId: state.provinceId,
            cityId    : state.cityId,
            ppId      : state.paymentPurposeId
        }

        console.log("params: ", params);
        console.log("stored state: ", state);

        let transactionState = state

        dispatch('displayBillPayment', params);
        state.showFormSet.billPayment = transactionState.isDisplayBillPayment

        dispatch('displayCollection', params);
        state.showFormSet.collection = transactionState.isDisplayCollection

        dispatch('displayDoorToDoor', params);
        state.showFormSet.doorToDoor = transactionState.isDisplayDoorToDoor

        dispatch('displayBeneficiaryName', params);
        state.showFormInput.root.beneficiaryName = transactionState.isDisplayBeneficiaryName.isDisplay
        state.beneficiaryNameLabel = transactionState.isDisplayBeneficiaryName.label

        dispatch('displayIdType', params);
        state.showFormInput.root.identificationType = transactionState.isDisplayIdType.isDisplay
        state.identificationTypeLabel = transactionState.isDisplayIdType.label

        dispatch('displayIdTypeSelect', params);
        state.showFormInput.root.idTypeSelect = transactionState.isDisplayIdTypeSelect

        //dispatch('displayHomeNo', params);
        //state.showFormInput.contact.homeNo = transactionState.isDisplayHomeNo

        dispatch('displayMobileNo', params);
        state.showFormInput.root.mobileNo = transactionState.isDisplayMobileNo.isDisplay
        state.mobileNoLabel = transactionState.isDisplayMobileNo.label

        dispatch('displayEmail', params);
        state.showFormInput.root.email = transactionState.isDisplayEmail.isDisplay
        state.emailLabel = transactionState.isDisplayEmail.label


        dispatch('displayPaymentPurpose', params);
        state.showFormInput.root.paymentPurpose = transactionState.isDisplayPaymentPurpose

        dispatch('displayPaymentPurposeOther', params);
        state.showFormInput.root.paymentPurposeOther = transactionState.isDisplayPaymentPurposeOther

        dispatch('displayAccountNo', params);        
        state.showFormInput.root.walletNo = false
        state.showFormInput.root.bankAccountNo = transactionState.isDisplayAccountNo.isDisplay
        state.bankAccountNoLabel = transactionState.isDisplayAccountNo.label

        dispatch('displayRefNo', params);
        state.showFormInput.root.refNo = transactionState.isDisplayRefNo.isDisplay
        state.refNoLabel = transactionState.isDisplayRefNo.label


        // 103 - BKASH && 18 - BANGLADESH
        if(state.transactionTypeId == 103 && state.homeCountryId == 18) {
            state.beneficiaryBankId = 4255;
            state.beneficiaryBankAccountName  = "BANGLADESH BKASH";
            state.isbKashTx = true;
        }
    },

        /* RESET FORM DATA */
    resetFormData({ dispatch, state }, params) {
        console.log("store: reset form data..", params)
        dispatch('resetDataStore')
        //this.resetDataStore(params);

        state.isbKashTx           = false;
        state.isDisplayErrorMsg   = false;
        state.radioErrorMsg       = "";

        state.beneficiaryFullName     = "";
        state.identificationType  = "";
        state.idTypeSelect        = "";
        state.idTypeSelectId      = 0;
        state.identificationNo    = "";
        state.street              = "";
        state.postcode            = "";
        state.locatingNote        = "";
        state.landmark            = "";
        state.bankAccountNo       = "";
        state.walletNo            = "";
        state.bankAccountName     = "";
        state.refNo               = "";
        state.paymentPurpose      = "";
        state.paymentPurposeId    = 0;
        state.paymentPurposeOther = "";
        state.homeNo              = "";
        state.mobileNo            = "";
        state.email               = "";

        state.showFormSet.billPayment                     = false;
        state.showFormSet.collection                      = false;
        state.showFormSet.doorToDoor                      = false;

        state.showFormInput.root.beneficiaryName          = false;
        state.showFormInput.root.paymentPurpose        = false;
        state.showFormInput.root.paymentPurposeOther   = false;
        state.showFormInput.root.homeNo                = true;
        state.showFormInput.root.mobileNo              = true;
        state.showFormInput.root.email                 = true;

        state.showFormInput.root.bankAccountNo            = false;
        state.showFormInput.root.walletNo                 = false;
        state.showFormInput.root.refNo                    = false;
    },
    /* END OF RESET FORM DATA*/

    /* RESET DATASTORE */
    resetDataStore({ state }, params) {
        console.log("store: reset datastore event: ", params);
        // reset datastore

        state.discountAmount      = 0

        state.beneficiaryName     = ""
        state.beneficiaryTypeId   = ""

        state.identificationType  = ""
        state.idTypeSelect        = ""
        state.idTypeSelectId      = 0
        state.identificationNo    = ""
        state.street              = ""
        state.postcode            = ""
        state.locatingNote        = ""
        state.landmark            = ""
        state.bankAccountNo       = ""
        state.walletNo            = ""
        state.bankAccountName     = ""
        state.refNo               = ""

        state.paymentPurpose      = ""
        state.paymentPurposeId    = 0
        state.homeIDD             = 0
        state.homeIDDCode         = ""
        state.homeNo              = ""
        state.mobileIDD           = 0
        state.mobileIDDCode       = ""
        state.mobileNo            = ""
        state.email               = ""
        state.isDataFilled        = false

        state.isDisplayBillPayment         = false
        state.isDisplayBankTransfer        = false
        state.isDisplayCollection          = false
        state.isDisplayDoorToDoor          = false

        state.isDisplayPostcode            = false
        state.isDisplayBeneficiaryName     = false
        state.isDisplayIdType              = false
        state.isDisplayIdTypeSelect        = false
        state.isDisplayIdNo                = false
        state.isDisplayAccountNo           = false
        state.isDisplayWalletNo            = false
        state.isDisplayRefNo               = false
        state.isDisplayPaymentPurpose      = false
        state.isDisplayPaymentPurposeOther = false
        state.isDisplayHomeNo              = false
        state.isDisplayMobileNo            = false
        state.isDisplayEmail               = false
        state.streetLabel                  = ""
    },
    /* END OF RESET DATASTORE */

    /* VALIDATE INPUT */
    validateInput({ state, dispatch }, inputEl) {
        let isValidInput           = false;
        let isHomeCountryValid     = false;
        //let isTransactionTypeValid = false;

        // COUNTRY
        if(inputEl.id === "homeCountry") {
            isHomeCountryValid = state.homeCountryId > 0;
            let inputState = isHomeCountryValid ? true : i18n.t('beneficiary-country-error');
            dispatch('setValidateInputState', {name: inputEl, value: inputState});
        }


        // BENEFICIARY NAME || PHIL GOV SERVICE NAME || BILL ACCOUNT NAME
        if(inputEl.id == "beneficiaryName" || inputEl.id == "billAccountName") {
            const params = {
                txTypeId  : state.transactionTypeId,
                dmId      : state.deliveryMethodId,
                bankTypeId: state.bankTypeId,
                name      : inputEl.value
            }
            dispatch('validateBeneficiaryName', params);
            isValidInput = state.isValidBeneficiaryName;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // IDENTIFICATION TYPE
        else if(inputEl.id == "identificationType") {
            const params = {
                countryId: state.homeCountryId,
                idType   : inputEl.value
            }
            dispatch('validateIdentificationType', params);
            isValidInput = state.isValidIdType;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // IDENTIFICATION TYPE SELECT
        else if(inputEl.id == "idTypeSelect") {
            dispatch('validateIdTypeSelect', state.idTypeSelectId);
            isValidInput = state.isValidIdTypeSelect;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // IDENTIFICATION NUMBER
        else if(inputEl.id == "identificationNo" || inputEl.id == "cnIdentificationNo") {
            const params = {
                countryId: state.homeCountryId,
                idNo     : inputEl.value
            }
            dispatch('validateIdentificationNo', params);
            isValidInput = state.isValidIdNo;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // STREET || ADDRESS
        else if(inputEl.id == "street" || inputEl.id == "address") {
            dispatch('validateStreet', inputEl.value);
            isValidInput = state.isValidStreet;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // POSTCODE
        else if(inputEl.id == "postcode" || inputEl.id == "audPostcode") {
            const params = {
                countryId : state.homeCountryId,
                txTypeId  : state.transactionTypeId,
                dmId      : state.deliveryMethodId,
                bankId    : state.beneficiaryBankId,
                bankTypeId: state.bankTypeId,
                provinceId: state.provinceId,
                cityId    : state.cityId,
                postcode  : inputEl.value,
                postcodeField: inputEl.id
            }
            isValidInput = dispatch('finalValidatePostcode', params);
        }
        // BANK ACCOUNT NUMBER || WALLET NO
        else if(inputEl.id == "bankAccountNo" || inputEl.id == "billAccountNo"  || inputEl.id == "walletNo") {
            const params = {
                countryId : state.homeCountryId,
                txTypeId  : state.transactionTypeId,
                dmId      : state.deliveryMethodId,
                bankId    : state.beneficiaryBankId,
                bankTypeId: state.bankTypeId,
                accountNo : inputEl.value
            }

            let isWallet       = (params.txTypeId == 2 && params.dmId == 1 && params.bankTypeId == 2) ? true : false

            dispatch('validateAccountNo', params);
            if(isWallet){
                isValidInput = state.isValidWalletNo;
            }else{
                isValidInput = state.isValidAccountNo;
            }
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // REF NO
        else if(inputEl.id == "refNo") {
            const params = {
                countryId : state.homeCountryId,
                txTypeId  : state.transactionTypeId,
                dmId      : state.deliveryMethodId,
                bankTypeId: state.bankTypeId,
                refNo     : inputEl.value
            }
            dispatch('validateRefNote', params);
            isValidInput = state.isValidRefNo;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // PAYMENT PURPOSE
        else if(inputEl.id == "paymentPurpose" || inputEl.id == "paymentPurposeOther") {
            const params = {
                ppId    : state.paymentPurposeId,
                ppOther : state.paymentPurposeOther
            }
            isValidInput = dispatch('finalValidatePaymentPurpose', inputEl.id, params);
        }
        // HOME TELEPHONE
        else if(inputEl.id == 'homeNo') {
            const params = {
                countryId: state.homeCountryId,
                homeNo   : inputEl.value,
                homeIDD  : state.homeIDD
            }
            isValidInput = dispatch('finalValidateHomePhone', params);
        }
        // MOBILE TELEPHONE
        else if(inputEl.id == "mobileNo") {
            const params = {
                countryId : state.homeCountryId,
                txTypeId  : state.transactionTypeId,
                dmId      : state.deliveryMethodId,
                bankTypeId: state.bankTypeId,
                mobileNo  : inputEl.value,
                mobileIDD : state.mobileIDD
            }
            isValidInput = dispatch('finalValidateMobilePhone', params);
        }
        // EMAIL
        else if(inputEl.id == "email") {
            const params = {
                countryId : state.homeCountryId,
                txTypeId  : state.transactionTypeId,
                dmId      : state.deliveryMethodId,
                bankTypeId: state.bankTypeId,
                email     : inputEl.value
            }
            dispatch('validateEmail', params);
            isValidInput = state.isValidEmail;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        else {
            isValidInput = true;
        }

        dispatch('setIsFormInputValid', isValidInput);
    },
    /* END OF VALIDATE INPUT */

     /* FINAL VALIDATION INPUT */
    finalValidatePostcode({ dispatch, state }, params) {
        console.log("params: ", params)
        let isValidInput = true
        dispatch('validatePostcode', params);

        setTimeout(() => {
            if(state.isValidPostcode != undefined) {
                isValidInput = state.isValidPostcode.inputState
                dispatch('setValidateInputState', {name: params.postcodeField, value: isValidInput});

                let isChangeProvince = isValidInput == true
                                    ? true
                                    : (isValidInput == i18n.t('beneficiary-postcode-info') ? true : false)
                if(isChangeProvince) {
                    let newProvinceId = state.isValidPostcode.provinceId
                    if(state.homeCountryId == 13 && state.provinceId != newProvinceId) {
                        dispatch('changeProvince', newProvinceId);
                    }
                }
            }
        }, 2000)

        //return isValidInput
    },

    finalValidatePaymentPurpose({ dispatch, state }, params) {
        console.log("pp params: ", params)
        //let $$           = this.Dom7;
        let isValidInput = true;
        dispatch('validatePaymentPurpose', params);


        dispatch('displayPaymentPurposeOther', params);
        dispatch('setShowFormInputPaymentPurposeOther', state.isDisplayPaymentPurposeOther)

        isValidInput = state.isValidPaymentPurpose;
        dispatch('setValidateInputState', {name: params.purposeField, value: isValidInput});

        //return isValidInput;
    },

    finalValidateHomePhone({ dispatch, state }, params) {
        let isValidInput = true;
        dispatch('validateHomeNo', params);

        let homeNoTemp = params.homeNo != undefined ? params.homeNo.trim() : params.homeNo;
        if(homeNoTemp.length > 0) {
            dispatch('changeHomePhoneCode', params.homeIDD);
        }

        isValidInput = state.isValidHomeNo;
        dispatch('setValidateInputState', {name: 'homeNo', value: isValidInput});

        //return isValidInput;
    },

    finalValidateMobilePhone({ dispatch, state }, params) {
        let isValidInput = true;
        dispatch('validateMobileNo', params);

        let mobileNoTemp = params.mobileNo != undefined ? params.mobileNo.trim() : params.mobileNo;
        if(mobileNoTemp.length > 0) {
            dispatch('changeMobilePhoneCode', params.mobileIDD);
        }

        isValidInput = state.isValidMobileNo;
        dispatch('setValidateInputState', {name: 'mobileNo', value: isValidInput});

        //return isValidInput;
    },
    /* END OF FINAL VALIDATION INPUT */

    /* MOBILE & HOME PHONE */
    changeHomePhoneCode({ state, dispatch }, homeId) {
        for(let i=0; i < state.countryCodeList.length; i++) {
            let thisHomeCC = state.countryCodeList[i]
            if(thisHomeCC.id == homeId) {
                dispatch('setHomeIDD', {id: thisHomeCC.id, name: thisHomeCC.idd});
                break;
            }
        }
    },

    changeMobilePhoneCode({ state, dispatch }, mobileId) {
        for(let i=0; i < state.countryCodeList.length; i++) {
            let thisMobileCC = state.countryCodeList[i]
            if(thisMobileCC.id == mobileId) {
                dispatch('setMobileIDD', {id: thisMobileCC.id, name: thisMobileCC.idd});
                break;
            }
        }
    },
    /* END OF MOBILE & HOME PHONE */

    /* BILL CORP */
    // changeBillCorp({ state, dispatch }, billCorpName) {
    //     const billCorpList  = state.billCorporationList;
    //     let isValidBillCorp = false;

    //     Object.keys(billCorpList).forEach(key => {
    //         if(billCorpList[key].toLowerCase() == billCorpName.toLowerCase()) {
    //             dispatch('setBillCorp', {id: key, name: billCorpList[key]});
    //             isValidBillCorp          = true;
    //             return;
    //         }
    //     })

    //     if(!isValidBillCorp) {
    //         dispatch('setBillCorp', {id: 0, name: ''});
    //     }

    //     if(state.bankAccountNo > 0) {
    //         dispatch('loadBillCorpDetails', state.bankAccountNo);
    //     }
    // },

    // async loadBillCorpDetails({ dispatch }, billCorporationId) {
    //     //const billCorpPromise = await this.$api.beneficiary.getBillCorporationDetails(billCorporationId);
    //     //const billCorp        = billCorpPromise

    //     dispatch('setShowPreloaderState', {name: "billCorp", value: false});
    // },
    /* END OF BILL CORP */

    changeIdType({ state, dispatch }, idTypeId) {
        const itList = state.idTypeList;

        Object.keys(itList).forEach(key => {
            if(key.toLowerCase() == idTypeId) {
                dispatch('setIdTypeSelect', {id: key, name: itList[key]});
                return;
            }
        })
    },

    /* PAYMENT PURPOSE */
    changePaymentPurpose({ state, dispatch }, ppId) {
        for(let i=0; i < state.paymentPurposeList.length; i++) {
            let thisPP = state.paymentPurposeList[i]
            if(thisPP.key == ppId) {
                dispatch('setPaymentPurpose', {id: ppId, name: thisPP.value});
                dispatch('setValidateInputState', {name: "paymentPurpose", value: true});
                break;
            }
        }

        if(ppId == -1){
            dispatch('setShowFormInputPaymentPurposeOther', true);
        }else{
            dispatch('setPaymentPurposeOther', '');
            dispatch('setShowFormInputPaymentPurposeOther', false);
        }
    },
    /* END OF PAYMENT PURPOSE */

    /* FORCE RE-RENDER */
    setForceRerenderKey({ commit }, value) {
        commit('setForceRerenderKey', value);
    },
    /* END OF FORCE RE-RENDER */

    setValidateInputState({ commit }, params) {
        commit('setValidateInputState', params);
    },
    setShowPreloaderState({ commit }, params) {
        commit('setShowPreloaderState', params);
    },
    setFormSetBankTransfer({ commit }, value) {
        commit('setFormSetBankTransfer', value);
    },
    setFormSetBillPayment({ commit }, value) {
        commit('setFormSetBillPayment', value);
    },
    setFormSetCollection({ commit }, value) {
        commit('setFormSetCollection', value);
    },
    setBankTypeId({ commit }, value) {
        commit('setBankTypeId', value);
    },
    setDeliveryMethod({ commit }, params) {
        commit('setDeliveryMethod', params);
    },
    setHomeCountryList({ commit }, value) {
        commit('setHomeCountryList', value);
    },
    setDmExternalName({ commit }, params) {
        commit('setDmExternalName', params);
    },
    setHomeCountry({ commit }, params) {
        commit('setHomeCountry', params);
    },
    setHomeCurrency({ commit }, params) {
        commit('setHomeCurrency', params);
    },
    setHostCountry({ commit }, params) {
        commit('setHostCountry', params);
    },
    setHostCurrency({ commit }, params) {
        commit('setHostCurrency', params);
    },
    setHomeIDD({ commit }, params) {
        commit('setHomeIDD', params);
    },
    setMobileIDD({ commit }, value) {
        commit('setMobileIDD', value);
    },
    setBeneficiaryName({ commit }, value) {
        commit('setBeneficiaryName', value);
    },
    setBeneficiaryTypeId({ commit }, value) {
        commit('setBeneficiaryTypeId', value);
    },
    setIdentificationType({ commit }, value) {
        commit('setIdentificationType', value);
    },
    setIdTypeSelect({ commit }, value) {
        commit('setIdTypeSelect', value);
    },
    setIdTypeList({ commit }, value) {
        commit('setIdTypeList', value);
    },
    setIdentificationNo({ commit }, value) {
        commit('setIdentificationNo', value);
    },
    setBankAccountNoLabel({ commit }, value) {
        commit('setBankAccountNoLabel', value);
    },
    setEmailLabel({ commit }, value) {
        commit('setEmailLabel', value);
    },
    setShowFormInputContactEmail({ commit }, value) {
        commit('setShowFormInputContactEmail', value);
    },
    setBankAccountNo({ commit }, value) {
        commit('setBankAccountNo', value);
    },
    setWalletNo({ commit }, value) {
        commit('setWalletNo', value);
    },
    setBankAccountName({ commit }, value) {
        commit('setBankAccountName', value);
    },
    setPaymentPurpose({ commit }, params) {
        commit('setPaymentPurpose', params);
    },
    setPaymentPurposeOther({ commit }, value) {
        commit('setPaymentPurposeOther', value);
    },
    setPaymentPurposeList({ commit }, value) {
        commit('setPaymentPurposeList', value);
    },
    setProvinceList({ commit }, value) {
        commit('setProvinceList', value);
    },
    setTransactionType({ commit }, params) {
        commit('setTransactionType', params);
    },
    setRefNo({ commit }, value) {
        commit('setRefNo', value);
    },
    setBillCorp({ commit }, params) {
        commit('setBillCorp', params);
    },
    setBillCorporationList({ commit }, value) {
        commit('setBillCorporationList', value);
    },
    setCountryCodeList({ commit }, value) {
        commit('setCountryCodeList', value);
    },
    setStreet({ commit }, value) {
        commit('setStreet', value);
    },
    setPostcode({ commit }, value) {
        commit('setPostcode', value);
    },
    setStreetLabel({ commit }, value) {
        commit('setStreetLabel', value);
    },
    setLocatingNote({ commit }, value) {
        commit('setLocatingNote', value);
    },
    setLandmark({ commit }, value) {
        commit('setLandmark', value);
    },
    setRadioErrorMsg({ commit }, value) {
        commit('setRadioErrorMsg', value);
    },
    setIsDisplayErrorMsg({ commit }, value) {
        commit('setIsDisplayErrorMsg', value);
    },
    setHomeNo({ commit }, value) {
        commit('setHomeNo', value);
    },
    setMobileNo({ commit }, value) {
        commit('setMobileNo', value);
    },
    setEmail({ commit }, value) {
        commit('setEmail', value);
    },
    setShowFormInputPaymentPurposeOther({ commit }, value) {
        commit('setShowFormInputPaymentPurposeOther', value);
    },
    setIsFormInputValid({ commit }, value) {
        commit('setIsFormInputValid', value);
    },

    setDisplayDeliveryMethod({ commit }, params){
        var statusName='';

        switch(params.deliveryStatusId) {
            case parseInt(process.env.VUE_APP_DELIVERY_STATUS_PENDING)    :  statusName = (params.agentPaymentStatusId >= 10 ) ?  i18n.t('general-text-category-pending') : i18n.t('general-text-category-unpaid'); break;
            case parseInt(process.env.VUE_APP_DELIVERY_STATUS_IN_TRANSIT) : statusName = i18n.t('general-text-category-intransit'); break;
            case parseInt(process.env.VUE_APP_DELIVERY_STATUS_COMPLETED)  : statusName = i18n.t('general-text-category-completed'); break;
            case parseInt(process.env.VUE_APP_DELIVERY_STATUS_FAILED)     : statusName = i18n.t('general-text-category-unsuccesful'); break;
            case parseInt(process.env.VUE_APP_DELIVERY_STATUS_CANCELLED)  : statusName = i18n.t('general-text-cancelled-status'); break;
            case parseInt(process.env.VUE_APP_DELIVERY_STATUS_REFUNDED)   : statusName = i18n.t('general-text-category-refunded'); break;
            case parseInt(process.env.VUE_APP_DELIVERY_STATUS_SUSPENDED)   : statusName = (params.agentPaymentStatusId >= 10 ) ?  i18n.t('general-text-category-pending') : i18n.t('general-text-category-unpaid'); break;
            default : statusName = params.deliveryStatus; break;
        }

        commit('setTransactionStatusName', statusName);
    },

    setTransactionDetail({ commit, dispatch }, params){
        dispatch('setDisplayDeliveryMethod', {deliveryStatusId: params.deliveryStatusId, deliveryStatus: params.deliveryStatus, agentPaymentStatusId: params.agentPaymentStatusId });

        commit('setTransactionDetail', params);
    },

    resetTransactionFormData({ commit }){
        commit('resetTransactionFormData');
    },

    loadIsDisplayAccountNo({ commit }) {
        commit('loadIsDisplayAccountNo');
    },
    loadIsDisplayWalletNo({ commit }) {
        commit('loadIsDisplayWalletNo');
    },
}

const mutations = {

    resetTransactionState (state) {
        Object.assign(state, getDefaultState())
    },
    setValidateInputState(state, payload){
        state.validateInputState.name = payload.name;
        state.validateInputState.value = payload.value;
    },
    setForceRerenderKey(state, value){
        if(value == "paymentPurpose"){
            state.forceRerenderKey.componentPaymentPurposeKey += 1;
        }
    },
    setShowPreloaderState(state, payload){
        state.showPreloaderState.name = payload.name;
        state.showPreloaderState.value = payload.value;
    },

    setFormSetBankTransfer(state, payload){
        state.showFormSet.bankTransfer = payload
    },
    setFormSetBillPayment(state, payload){
        state.showFormSet.billPayment = payload
    },
    setFormSetCollection(state, payload){
        state.showFormSet.collection = payload
    },
    setBankTypeId(state, payload){
        state.bankTypeId = payload;
    },
    setDeliveryMethod(state, payload){
        state.deliveryMethodId = (payload == undefined || payload.id == undefined) ? 0 : payload.id;
        state.deliveryMethod = (payload == undefined || payload.name == undefined) ? "" : payload.name;
    },
    setDmExternalName(state, payload) {
        state.dmExternalName = payload;
    },
    setHomeCountryList(state, payload) {
        state.homeCountryList = payload;
    },
    setHomeCountry(state, payload){
        state.homeCountryId = payload.id;
        state.homeCountryIdd = payload.idd;
        state.homeCountryName = payload.name;
    },
    setHomeCurrency(state, payload){
        state.homeCurrencyId = payload.id;
        state.homeCurrency = payload.name;
    },
    setHostCountry(state, payload){
        state.hostCountryId = payload.id;
        state.hostCountryName = payload.name;
    },
    setHostCurrency(state, payload){
        state.hostCurrencyId = payload.id;
        state.hostCurrency = payload.name;
    },
    setHomeIDD(state, payload) {
        state.homeIDD = payload.id;
        state.homeIDDCode = payload.name;
    },
    setMobileIDD(state, payload) {
        state.mobileIDD = payload.id;
        state.mobileIDDCode = payload.name;
    },
    setBeneficiaryName(state, payload){
        state.beneficiaryFullName = payload;
    },
    setBeneficiaryTypeId(state, payload){
        state.beneficiaryTypeId = payload;
    },
    setIdentificationType(state, payload){
        state.identificationType = (payload == undefined) ? "" : payload ;
    },
    setIdTypeSelect(state, payload){
        state.idTypeSelectId = payload.id;
        state.idTypeSelect = payload.name;
    },
    setIdTypeList(state, payload) {
        state.idTypeList = payload;
    },
    setIdentificationNo(state, payload) {
        state.identificationNo = (payload == undefined) ? "" : payload;
    },
    setBankAccountNoLabel(state, payload){
        state.bankAccountNoLabel = payload;
    },
    setEmailLabel(state, payload){
        state.emailLabel = payload;
    },
    setShowFormInputPaymentPurposeOther(state, payload){
        state.showFormInput.root.paymentPurposeOther = payload;
    },
    setShowFormInputContactEmail(state, payload){
        state.showFormInput.root.email = payload;
    },
    setBankAccountNo(state, payload){
        state.bankAccountNo = payload;
    },
    setWalletNo(state, payload){
        state.walletNo = payload;
    },
    setBankAccountName(state, payload){
        state.bankAccountName = payload;
    },
    setPaymentPurpose(state, payload){
        state.paymentPurposeId = (payload == undefined || payload.id == undefined) ? 0 : payload.id;
        state.paymentPurpose = (payload == undefined || payload.name == undefined) ? "" : payload.name;
    },
    setPaymentPurposeOther(state, payload) {
        state.paymentPurposeOther = payload;
    },
    setPaymentPurposeList(state, payload) {
        state.paymentPurposeList = payload;
    },
    setProvinceList(state, payload) {
        state.provinceList = payload;
    },
    setTransactionType(state, payload){
        state.transactionTypeId = payload.id;
        state.transactionType = payload.name;
    },
    setRefNo(state, payload) {
        state.refNo = payload;
    },
    setBillCorp(state, payload) {
        state.billCorporationId = payload.id;
        state.billCorporationName = payload.name;
    },
    setBillCorporationList(state, payload) {
        state.billCorporationList = payload;
    },
    setCountryCodeList(state, payload) {
        payload.forEach(function(item,i){
            if(item.id === 189){
                payload.splice(i, 1);
                payload.unshift(item);
            }
        });
        state.countryCodeList = payload;
    },
    setStreet(state, payload) {
        state.street = payload;
    },
    setPostcode(state, payload) {
        state.postcode = payload;
    },
    setStreetLabel(state, payload) {
        state.streetLabel = payload;
    },
    setLocatingNote(state, payload) {
        state.locatingNote = payload;
    },
    setLandmark(state, payload) {
        state.landmark = payload;
    },
    setRadioErrorMsg(state, payload) {
        state.radioErrorMsg = payload;
    },
    setIsDisplayErrorMsg(state, payload) {
        state.isDisplayErrorMsg = payload;
    },
    setHomeNo(state, payload) {
        state.homeNo = payload;
    },
    setMobileNo(state, payload) {
        state.mobileNo = payload;
    },
    setEmail(state, payload) {
        state.email = payload;
    },
    setIsFormInputValid(state, payload) {
        state.isFormInputValid = payload;
    },
    loadIsDisplayBillPayment(state, isDisplayBillPayment) {
        state.isDisplayBillPayment = isDisplayBillPayment;
    },
    loadIsDisplayBankTransfer(state, isDisplayBankTransfer) {
        state.isDisplayBankTransfer = isDisplayBankTransfer;
    },
    loadIsDisplayCollection(state, isDisplayCollection) {
        state.isDisplayCollection = isDisplayCollection;
    },
    loadIsDisplayDoorToDoor(state, isDisplayDoorToDoor) {
        state.isDisplayDoorToDoor = isDisplayDoorToDoor;
    },
    loadIsDisplayPostcode(state, isDisplayPostcode) {
        state.isDisplayPostcode = isDisplayPostcode;
    },
    loadIsDisplayBeneficiaryName(state, isDisplayBeneficiaryName) {
        state.isDisplayBeneficiaryName = isDisplayBeneficiaryName;
    },
    loadIsDisplayIdType(state, isDisplayIdType) {
        state.isDisplayIdType = isDisplayIdType;
    },
    loadIsDisplayIdTypeSelect(state, isDisplayIdTypeSelect) {
        state.isDisplayIdTypeSelect = isDisplayIdTypeSelect;
    },
    loadIsDisplayIdNo(state, isDisplayIdNo) {
        state.isDisplayIdNo = isDisplayIdNo;
    },
    loadIsDisplayAccountNo(state, isDisplayAccountNo) {
        state.isDisplayAccountNo = isDisplayAccountNo;
    },
    loadIsDisplayWalletNo(state, isDisplayWalletNo) {
        state.isDisplayWalletNo = isDisplayWalletNo;
    },
    loadIsDisplayRefNo(state, isDisplayRefNo) {
        state.isDisplayRefNo = isDisplayRefNo;
    },
    loadIsDisplayPaymentPurpose(state, isDisplayPaymentPurpose) {
        state.isDisplayPaymentPurpose = isDisplayPaymentPurpose;
    },
    loadIsDisplayPaymentPurposeOther(state, isDisplayPaymentPurposeOther) {
        state.isDisplayPaymentPurposeOther = isDisplayPaymentPurposeOther;
    },
    loadIsDisplayHomeNo(state, isDisplayHomeNo) {
        state.isDisplayHomeNo = isDisplayHomeNo;
    },
    loadIsDisplayMobileNo(state, isDisplayMobileNo) {
        state.isDisplayMobileNo = isDisplayMobileNo;
    },
    loadIsDisplayEmail(state, isDisplayEmail) {
        state.isDisplayEmail = isDisplayEmail;
    },
    loadStreetLabel(state, streetLabel) {
        state.streetLabel = streetLabel;
    },
    loadIsValidBillCorp(state, isValidBillCorp) {
        state.isValidBillCorp = isValidBillCorp;
    },
    loadIsValidBeneficiaryName(state, isValidBeneficiaryName) {
        state.isValidBeneficiaryName = isValidBeneficiaryName;
    },
    loadIsValidIdType(state, isValidIdType) {
        state.isValidIdType = isValidIdType;
    },
    loadIsValidIdTypeSelect(state, isValidIdTypeSelect) {
        state.isValidIdTypeSelect = isValidIdTypeSelect;
    },
    loadIsValidIdNo(state, isValidIdNo) {
        state.isValidIdNo = isValidIdNo;
    },
    loadIsValidStreet(state, isValidStreet) {
        state.isValidStreet = isValidStreet;
    },
    loadIsValidPostcode(state, isValidPostcode) {
        state.isValidPostcode = isValidPostcode;
    },
    loadIsValidAccountNo(state, isValidAccountNo) {
        state.isValidAccountNo = isValidAccountNo;
    },
    loadIsValidWalletNo(state, isValidWalletNo) {
        state.isValidWalletNo = isValidWalletNo;
    },
    loadIsValidRefNo(state, isValidRefNo) {
        state.isValidRefNo = isValidRefNo;
    },
    loadIsValidPaymentPurpose(state, isValidPaymentPurpose) {
        state.isValidPaymentPurpose = isValidPaymentPurpose;
    },
    loadIsValidHomeNo(state, isValidHomeNo) {
        state.isValidHomeNo = isValidHomeNo;
    },
    loadIsValidMobileNo(state, isValidMobileNo) {
        state.isValidMobileNo = isValidMobileNo;
    },
    loadIsValidEmail(state, isValidEmail) {
        state.isValidEmail = isValidEmail;
    },
    loadCheckPreventOnlySpecial(state, isValidCheckOnlySpecial) {
        state.isValidCheckOnlySpecial = isValidCheckOnlySpecial;
    },

    setTransactionStatusName(state, payload) {
        state.transactionStatusName = payload;
    },

    setTransactionDetail(state, params){
        const selectedTransaction = params
        const philgovDetail       = params.transactionPhilGovLinkDTO

        state.allowToModify                 = selectedTransaction.allowToModify;
        state.agentPaymentStatus            = selectedTransaction.agentPaymentStatus;
        state.agentPaymentStatusId          = selectedTransaction.agentPaymentStatusId;
        state.beneficiaryBank               = selectedTransaction.beneficiaryBank;
        state.beneficiaryBankAccountName    = selectedTransaction.beneficiaryBankAccountName;
        state.bankAccountNo                 = selectedTransaction.beneficiaryBankAccountNo;
        state.bankAccountName               = selectedTransaction.beneficiaryBankAccountName;
        state.bankId                        = selectedTransaction.beneficiaryBankId;
        state.bankBranchId                  = selectedTransaction.beneficiaryBankBranchId;
        state.bankName                      = selectedTransaction.beneficiaryBank;
        state.beneficiaryAlias              = selectedTransaction.beneficiaryBankAccountName;
        state.beneficiaryBankId             = selectedTransaction.beneficiaryBankId;
        state.beneficiaryBankBranch         = selectedTransaction.beneficiaryBankBranch;
        state.beneficiaryBankBranchId       = selectedTransaction.beneficiaryBankBranchId;
        state.beneficiaryFirstName          = selectedTransaction.beneficiaryName;
        state.beneficiaryFullName           = selectedTransaction.beneficiaryName;
        state.beneficiaryId                 = selectedTransaction.beneficiaryID;
        state.beneficiaryIdType             = selectedTransaction.beneficiaryIdType;
        state.beneficiaryPhoneNo            = selectedTransaction.beneficiaryPhoneNo;
        state.billingOrg                    = (selectedTransaction.deliveryMethodId == 0) ? selectedTransaction.beneficiaryBank : "",
        state.billerCode                    = (selectedTransaction.deliveryMethodId == 0) ? selectedTransaction.billerCode : 0,
        state.collectionAgent               = (selectedTransaction.deliveryMethodId == 3) ? selectedTransaction.beneficiaryBank : "",
        state.collectionAgentId             = (selectedTransaction.deliveryMethodId == 3) ? selectedTransaction.beneficiaryBankId : 0,
        state.createdDateTime               = selectedTransaction.createdDateTime;
        state.deliveryMethodId              = selectedTransaction.deliveryMethodId;
        state.deliveryMethodName            = selectedTransaction.deliveryMethod;
        state.deliveryStatus                = selectedTransaction.deliveryStatus;
        state.deliveryDateTime              = selectedTransaction.deliveryDateTime;
        state.deliveryStatusId              = selectedTransaction.deliveryStatusId;
        state.deliveryStatusHistoryList     = selectedTransaction.deliveryStatusHistoryList;
        state.distributionPaymentStatus     = selectedTransaction.distributionPaymentStatus;
        state.distributionPaymentStatusId   = selectedTransaction.distributionPaymentStatusId;
        state.exchangeRate                  = selectedTransaction.exchangeRate;
        state.externalDeliveryStatus        = selectedTransaction.externalDeliveryStatus;
        state.homeAmount                    = selectedTransaction.homeAmount;
        state.homeAmountReal                = selectedTransaction.homeAmount;
        state.homeCountryId                 = selectedTransaction.homeCountryId;
        state.homeCountryName               = selectedTransaction.homeCountry;
        state.homeCurrency                  = selectedTransaction.homeCurrency;
        state.homeCurrencyId                = selectedTransaction.homeCurrencyId;
        state.hostAmount                    = selectedTransaction.hostAmount;
        state.hostAmountReal                = selectedTransaction.hostAmount;
        state.hostCountryId                 = selectedTransaction.hostCountryId;
        state.hostCountryName               = selectedTransaction.hostCountry;
        state.hostCurrency                  = selectedTransaction.hostCurrency;
        state.hostCurrencyId                = selectedTransaction.hostCurrencyId;
        state.isQuickSend                   = false;
        state.isOutstanding                 = false;
        state.paymentDateTime               = selectedTransaction.paymentDateTime;
        state.paymentMethodId               = selectedTransaction.paymentMethodId;
        state.paymentMethod                 = selectedTransaction.paymentMethod;
        state.paymentPurpose                = selectedTransaction.paymentPurpose;
        state.settlementId                  = selectedTransaction.settlementId;
        state.settlementOutstandingAmount   = selectedTransaction.settlementOutstandingAmount;
        state.settlementStatusId            = selectedTransaction.settlementStatusId;
        state.settlementTxnIds              = selectedTransaction.settlementTxnIds;
        state.transactionId                 = selectedTransaction.transactionId;
        state.transactionType               = selectedTransaction.transactionType;
        state.transactionTypeId             = selectedTransaction.transactionTypeId;
        state.transactionIds                = selectedTransaction.settlementTxnIds;
        state.transactionCharges            = selectedTransaction.transactionCharges;
        state.transactionChargesWaived      = selectedTransaction.transactionChargesWaived;
        state.commissionAmount              = selectedTransaction.transactionCharges;
        state.discountAmount                = selectedTransaction.discountValue;

        if(philgovDetail != undefined){
            state.endYear                       = philgovDetail.endYear
            state.endMonth                      = philgovDetail.endMonth - 1
            state.flexiFund                     = philgovDetail.flexiFund
            state.loanNumber                    = philgovDetail.loanNumber
            state.mp2No                         = philgovDetail.mp2
            state.prnNo                         = philgovDetail.prn
            state.startMonth                    = philgovDetail.startMonth-1
            state.startYear                     = philgovDetail.startYear
        }
    },

    resetTransactionFormData(state){
        state.activeBidRate               = 0,
        state.allowToModify               = false,
        state.agentPaymentStatus          = "",
        state.agentPaymentStatusId        = 0,
        state.bankAccountNo               = "",
        state.bankAccountName             = "",
        state.bankExpressId               = 0,
        state.bankId                      = 0,
        state.bankBranchId                = 0,
        state.bankName                    = "",
        state.bankTypeId                  = 0,
        state.beneficiaryAlias            = "",
        state.beneficiaryBank             = "",
        state.beneficiaryBankAccountName  = "",
        state.beneficiaryBankAccountNo    = "",
        state.beneficiaryBankId           = 0,
        state.beneficiaryBankBranch       = "",
        state.beneficiaryBankBranchId     = 0,
        state.beneficiaryFirstName        = "",
        state.beneficiaryFullName         = "",
        state.beneficiaryId               = 0,
        state.beneficiaryIdType           = 0,
        state.beneficiaryPhoneNo          = 0,
        state.beneficiaryTypeId           = 0,
        state.createdDateTime             = {year:0, month:0, dayOfMonth:0, hourOfDay:0, minute:0,second:0},
        state.billerCode                  = 0,
        state.billingOrg                  = "",
        state.city                        = "",
        state.cityId                      = 0,
        state.collectionAgent             = "",
        state.collectionAgentId           = 0,
        state.commissionAmount            = 0,
        state.contribution                = 0,
        state.contributionObj             = [],
        state.convenienceFee              = 0, // fee
        state.convenienceFeeByPercentage  = 0, // fee by percentage
        state.convenienceTotalFees        = 0, // totalFee
        state.couponCode                  = "",
        state.creditCardName              = "",
        state.creditCardNo                = "",
        state.creditCardExpiryDate        = "",
        state.creditCardSecurityCode      = "",
        state.deliveryDateTime            = {year:0, month:0, dayOfMonth:0, hourOfDay:0, minute:0,second:0},
        state.deliveryMethodId            = 0,
        state.deliveryMethod              = "",
        state.deliveryStatus              = "",
        state.deliveryStatusId            = 0,
        state.deliveryStatusHistoryList   = [],
        state.dmExternalName              = "",
        state.discountAmount              = 0,
        state.discountDescription         = "",
        state.discountName                = "",
        state.distributionPaymentStatus   = "",
        state.distributionPaymentStatusId = 0,
        state.endMonth                    = 0,
        state.endYear                     = null,
        state.exchangeRate                = 0,
        state.expressAvailable            = 0,
        state.externalDeliveryStatus      = "",
        state.flexiFund                   = null,
        state.homeAmount                  = "",
        state.homeAmountReal              = 0,
        state.homeCountryId               = 0,
        state.homeCountryIdd              = "",
        state.homeCountryName             = "",
        state.homeCurrency                = "",
        state.homeCurrencyId              = 0,
        state.hostAmount                  = "",
        state.hostAmountReal              = 0,
        state.hostCountryId               = 0,
        state.hostCountryName             = "",
        state.hostCurrency                = "",
        state.hostCurrencyId              = 0,
        state.isExpressBankType           = 0,
        state.isOutstanding               = false,
        state.isQuickSend                 = false,
        state.isSettled                   = false,
        state.isShowCancel                = false,
        state.latestState                 = "",
        state.loanNumber                  = '',
        state.memberTypeId                = 0,
        state.monthlyAmount               = 0,
        state.mp2No                       = '',
        state.p2hCustomerId               = 0,
        state.partnerId                   = 0,
        state.paymentDateTime             = {year:0, month:0, dayOfMonth:0, hourOfDay:0, minute:0,second:0},
        state.paymentMethodId             = 0,
        state.paymentMethod               = "",
        state.paymentPurpose              = "",
        state.paymentPurposeId            = 0,
        state.paymentPurposeOther         = "",
        state.paymentTime                 = "11:00 A.M",
        state.prnNo                       = '',
        state.province                    = "",
        state.provinceId                  = 0,
        state.roundedAmount               = 0,
        state.serviceId                   = 0,
        state.settlementDetail            = "",
        state.settlementId                = 0,
        state.settlementPmId              = 0,
        state.settlementOutstandingAmount = 0,
        state.settlementStatusId          = 0,
        state.settlementTxnIds            = [],
        state.startMonth                  = 0,
        state.startYear                   = null,
        state.totSettlement               = 0,
        state.totalAmountPayable          = 0,
        state.totalAmountSettlement       = 0,
        state.totalAmountPaid             = [],
        state.totalReceivableAmountPaid   = [],
        state.transactionId               = 0,
        state.transactionType             = "",
        state.transactionTypeId           = 0,
        state.transactionIds              = [],
        state.transactionTypeIds          = [],
        state.transactionCharges          = 0,
        state.transactionChargesWaived    = false,
        state.transactionStatusName       = ""
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}